module.exports = " <div> <single-day v-if=dayLabel :day-label=dayLabel :day-number=dayNumber :date=date :index=0> </single-day> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/components/CalendarDay.vue
// module id = 323
// module chunks = 2